import PropTypes from 'prop-types'
import Link from 'next/link'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { useStyles } from './states.styles'

function getStateLinkData({ state, stateCode, stateName }) {
  const slug = stateCode ?? (String(state ?? '').length === 2 ? state : null)
  if (!slug) return null

  return {
    label: stateName ?? state,
    slug: String(slug).toLowerCase(),
  }
}

function sortStatesByLabel(a, b) {
  return a.label.localeCompare(b.label)
}

function States(props) {
  const { states, insideSearchBar = false } = props
  const styles = useStyles({ insideSearchBar })
  const headline = insideSearchBar ? 'or search by state' : 'Search for Courses by State'
  return (
    <Box py={insideSearchBar ? [5, 6, 3] : [5, 6, 9]} className={styles.root}>
      <Container>
        <Typography
          align={insideSearchBar ? 'left' : 'center'}
          variant={insideSearchBar ? 'subtitle2' : 'h4'}
        >{headline}
        </Typography>
        <div className={styles.statesContainer}>
          <ul data-testid="states">
            {states && states.map(getStateLinkData).filter(Boolean).sort(sortStatesByLabel).map(({ label, slug }) => (
              <li key={slug}>
                <Link href={`/play/${slug}`}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </Box>
  )
}

States.propTypes = {
  states: PropTypes.arrayOf(PropTypes.shape({
    state: PropTypes.string,
    stateCode: PropTypes.string,
    stateName: PropTypes.string,
  })),
  insideSearchBar: PropTypes.bool,
}

export default States
